import { InfoCircleOutlined } from '@ant-design/icons/lib/icons';
import { Tooltip } from 'antd';
import React from 'react';

import { massPropTypes } from '../../propTypes/mass';

import styles from './NoMassHourTooltip.module.scss';

export const NoMassHourTooltip = ({ mass }) => {
  if (mass.hasHour) {
    return null;
  }

  return (
    <Tooltip
      className={styles.Tooltip}
      title={
        <>
          Msza Święta bezgodzinowa ma określony dzień, w którym zostanie odprawiona, ale nie ma
          ustalonej godziny.
        </>
      }
    >
      &nbsp;
      <InfoCircleOutlined />
    </Tooltip>
  );
};

NoMassHourTooltip.propTypes = {
  mass: massPropTypes,
};
